<template>
	<div class="select-product-for-event-winner">
		<EventWinnerMappedPdtTable
			v-model="checkedProduct"
			:productList="params.winnerMappedPdtList"
		/>
		<div class="btn-wrap-main">
			<button
				type="button"
				class="btn-main blue"
				v-text="'선택 추가'"
				@click="addWinner"
			/>
		</div>
		<button
			type="button"
			class="select-product-for-event-winner__close-btn"
			@click="closing"
		>
			<i
				class="fas fa fa-times select-product-for-event-winner__close-btn-icon"
			/>
		</button>
	</div>
</template>
<script>
	import { mapState } from 'vuex';
	import EventWinnerMappedPdtTable from '../EventWinnerMappedPdtTable.vue';

	export default {
		name: 'SelectProductForEventWinner',
		components: {
			EventWinnerMappedPdtTable,
		},
		data() {
			return {
				checkedProduct: [],
			};
		},
		computed: {
			...mapState('modal', ['params']),
		},
		methods: {
			addWinner() {
				if (this.checkedProduct.length < 1) {
					alert('제품을 선택해주세요.');
					return;
				}
				this.params.addWinner(this.checkedProduct);
				this.$store.commit('modal/toggleModal', false);
			},
			closing() {
				this.$emit('close');
			},
		},
	};
</script>
<style lang="scss" scoped>
	.select-product-for-event-winner {
		&__close-btn {
			position: absolute;
			right: 35px;
			top: 30px;
			padding: 5px;

			&-icon {
				font-size: 30px;
			}
		}
	}
</style>
